import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {MessageService, ConfirmationService, LazyLoadEvent} from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import {Msg, MsgService} from '@app/_components/msg';
import {first} from 'rxjs/operators';

@Component({
    selector: 'app-msg-history',
    templateUrl: './msg-history.component.html',
    styleUrls: ['./msg-history.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class MsgHistoryComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private msgService: MsgService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = 'Find conversation by MailId';
	}

	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Input() msgCampaignId: any;
	@Input() listUpdated: false;
	// data
	msgHistoryId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	lazyLoadEventFirst: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	statuses: any;
	msgs: any;
	msg: Msg;
	columns: any[] = [
		{ field: 'Date', header: 'Date', width: 'auto' },
		{ field: 'receivedDate', header: 'Received Date', width: 'auto' },
		{ field: 'sentDate', header: 'Sent Date', width: 'auto' },
		{ field: 'senderName', header: 'Sender Name', width: 'auto' },
		{ field: 'senderEmail', header: 'Sender Email', width: 'auto' },
		{ field: 'subject', header: 'Subject', width: 'auto' }
	];

	validationMessages = {
		'email': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

	}




	findHistoryByMail() {
		this.loadLazy(this.lazyLoadEvent);
		/*try {
			this.msgService.fetchHistory(this.form1.value.email)
				.subscribe(
					(res: any) => {
						console.log('msgHistory-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('msgHistory-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}*/
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			email: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
		});
	}

	getStatusName(msg: any) {
		if (msg?.status) {
			const status = this.statuses.find((e: any) => e.value === msg.status);
			return status.name;
		} else {
			return '';
		}
	}

    onOpenFormEdit(msg: any) {
    }
	/*loadLazy1(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;
			/!*
             *
             * Default Sort
             *!/
			// https://stackoverflow.com/questions/679915/how-do-i-msg-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: "createDate", order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.msgService
				.fetchHistory(
					this.form1.value.email
				)
				.pipe()
				.subscribe(
					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.msgs = res.data.msgs;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log("reviews list error!: " + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {
						this.loading = false;
					}
				);

			if (this.datasource) {
				this.msgs = this.datasource.slice(
					event.first,
					event.first + event.rows
				);
			}
		} catch (error) {
			console.log("loadLazy(" + event + ")" + error);
		}
	}*/

	loadLazy(event: LazyLoadEvent) {
		if (!this.form1.value.email){
			this.lazyLoadEventFirst = event;
			this.loading = false;
			return false;
		}
		try {
			this.loading = true;
			if (!event){
				this.lazyLoadEvent = this.lazyLoadEventFirst;
			}
			else{
				this.lazyLoadEvent = event;
			}

			console.log(
				" event.first:" +
				event.first +
				"  |  event.rows:" +
				event.rows +
				"  |  event.sortField:" +
				event.sortField +
				"  |  event.sortOrder:" +
				event.sortOrder +
				"  |  event.multiSortMeta:" +
				JSON.stringify(event.multiSortMeta) +
				"  |  event.globalFilter:" +
				event.globalFilter +
				"  |  event.filters:" +
				JSON.stringify(event.filters)
			);

			/*
             *
             * Default Sort
             */
			// https://stackoverflow.com/questions/679915/how-do-i-msg-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: "createDate", order: -1 });
			}

			let emailFilter = { 'senderEmail': { 'value': this.form1.value.email, 'matchMode': 'in' } };
			Object.assign(event.filters, emailFilter);

			const pageNumber = Math.round(event.first / event.rows);
			this.msgService
				.fetchHistory(
					pageNumber,
					event.rows,
					event.sortField,
					event.sortOrder,
					event.multiSortMeta,
					event.globalFilter,
					event.filters
				)
				.pipe(first())
				.subscribe(
					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.msgs = res.data.msgs;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log("reviews list error!: " + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {
						this.loading = false;
					}
				);

			if (this.datasource) {
				this.msgs = this.datasource.slice(
					event.first,
					event.first + event.rows
				);
			}
		} catch (error) {
			console.log("loadLazy(" + event + ")" + error);
		}
	}
	onRowSelect(event: any) {
		console.log("onRowSelect: " + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}
}
